import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=31bce8ea&scoped=true&"
import script from "./ProfilePage.js?vue&type=script&lang=js&"
export * from "./ProfilePage.js?vue&type=script&lang=js&"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&id=31bce8ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bce8ea",
  null
  
)

export default component.exports